import { useLocalStorage } from '../hooks/use-local-storage';
import { Search } from '../state';

/**
 * Hook for managing unsaved search data in localStorage during the create/clone flow.
 * This allows users to reload the page without losing their unsaved search draft.
 *
 * @param jobId - The job ID associated with the unsaved search
 * @returns Tuple of [unsavedSearch, setUnsavedSearch, clearUnsavedSearch]
 */
export function useUnsavedSearch(jobId: string) {
    const storageKey = `unsaved-search-${jobId}`;

    const [unsavedSearch, setUnsavedSearch] = useLocalStorage<Partial<Search> | null>(storageKey, null);

    const clearUnsavedSearch = () => {
        setUnsavedSearch(null);
    };

    return [unsavedSearch, setUnsavedSearch, clearUnsavedSearch] as const;
}
